import{asChildPropDef as o}from"../props/as-child.prop.js";const e={...o,active:{type:"boolean",default:!1}};import{baseTabListPropDefs as t}from"./_internal/base-tab-list.props.js";export{e as tabNavLinkPropDefs,t as tabNavRootPropDefs};
//# sourceMappingURL=tab-nav.props.js.map
